export function formatAgeBand(dob) {
  if (!dob) return '';
  const age = Math.floor((Date.now() - new Date(dob).getTime()) / (365.25 * 24 * 3600 * 1000));
  if (age < 18) return '';
  if (age <= 22) return '18–22';
  if (age === 29) return '26–29';
  if (age === 39) return '36–39';
  if (age === 49) return '44–49';
  if (age === 59) return '54–59';
  if (age >= 60) return '60+';
  if (age <= 28) return (age - 2) + '–' + (age + 1);
  if (age <= 38) return (age - 3) + '–' + (age + 1);
  if (age <= 58) return (age - 4) + '–' + (age + 1);
  return '60+';
}
